// extracted by mini-css-extract-plugin
module.exports = {"groupOnly":"styles_groupOnly__oQ_pv","icon":"styles_icon__gCK4n"};